<template>
    <el-row class="menu_page">
         <el-col>
             <el-menu
                :default-active="activeIndex"
                mode="vertical"
                background-color="#484848"
                text-color="#fff"
                active-text-color="#101010" 
                class="el-menu-vertical-demo">
                <router-link to="/home">
                    <el-menu-item index="0">
                        <i class="fa fa-margin el-icon-menu"></i>
                        <span slot="title">首页</span>
                    </el-menu-item>
                </router-link>
                <!-- 只渲染当前角色有权限的菜单 -->
                <template  v-for="item in authMenuList" >
                    <el-submenu v-if="item.children" :index="item.path" :key="item.path">
                        <template slot="title">
                            <i :class="'fa fa-margin '+item.icon"></i>
                            <span slot="title">{{item.name}}</span>
                        </template>
                        <router-link v-for="(citem,cindex) in item.children" 
                            :to="citem.path" :key="cindex">
                            <el-menu-item 
                                :index='citem.path'>
                                <span slot="title">{{citem.name}}</span>
                            </el-menu-item> 
                        </router-link>
                    </el-submenu>
                </template>
             </el-menu>
         </el-col>
    </el-row>
</template>

<script>
export default {
    name: 'left-menu',
    created () {
        this.getInfo()
    },
    data () {
        return {
            // 原始完整菜单列表（抽离出来便于维护）
            allMenuList: [
                {
                    icon: 'el-icon-share',
                    name: '房屋信息管理',
                    path: 'house',
                    children: [{ path: 'houselist',name: '房屋信息操作'},{ path: 'housingstatistics',name: '房屋信息统计'}]
                },
                {
                    icon: 'el-icon-goods',
                    name: '租户管理',
                    path: 'tenant',
                    children: [{ path: 'tenantlist',name: '租户操作'}]
                },
                {
                    icon: 'el-icon-printer',
                    name: '租赁管理',
                    path: 'lease',
                    children: [{ path: 'leaseinfo',name: '租赁操作'}]
                },
                {
                    icon: 'el-icon-view',
                    name: '合同管理',
                    path: 'contractlist',
                    children: [{ path: 'contractList',name: '合同操作'}]
                },
                {
                    icon: 'el-icon-printer',
                    name: '商办管理',
                    path: 'officecheckin',
                    children: [{ path: 'officecheckinlist',name: '科创中心招商管理'},{ path: 'storeinformation',name: '邻里中心招商管理'}]
                },
                {
                    icon: 'el-icon-printer',
                    name: '物业管理',
                    path: 'propertyrepair',
                    children: [{ path: 'propertymanagementfee',name: '物业费管理'},{ path: 'propertyrepair',name: '维修管理'}]
                },
                {
                    icon: 'el-icon-printer',
                    name: '投诉管理',
                    path: 'propertycomplaint',
                    children: [{ path: 'propertycomplaint',name: '投诉操作'}]
                },
                {
                    icon: 'el-icon-phone',
                    name: '用户管理',
                    path: 'user',
                    children: [{ path: 'userlist',name: '用户操作'}]
                },
            ],
            // 权限过滤后的菜单列表（供页面渲染）
            authMenuList: []
        }
    },
    computed: {
        activeIndex(){
            return this.$route.path.replace('/','')
        },
        // 获取当前登录用户的角色（从store中获取，你可根据实际情况调整）
        currentRole() {
            // 实际项目中替换为：return this.$store.getters.user?.roles || ''
            // 这里先留空，后续从登录态中获取
            return this.$store.getters.user ? this.$store.getters.user.roles : '';
        }
    },
    methods: {
        getInfo(){
            // 根据角色过滤菜单
            this.filterMenuByRole();
        },
        // 核心方法：根据角色过滤菜单
        filterMenuByRole() {
            const role = this.currentRole;
            let menuNames = [];

            // 定义不同角色对应的可访问菜单名称
            switch(role) {
                case 'admin':
                    // 管理员：全部菜单
                    this.authMenuList = [...this.allMenuList];
                    break;
                case 'operatormanager':
                    // 运营管理员：指定菜单
                    menuNames = [
                        '房屋信息管理',
                        '租户管理',
                        '租赁管理',
                        '合同管理',
                        '物业管理',
                        '投诉管理'
                    ];
                    this.authMenuList = this.allMenuList.filter(menu => menuNames.includes(menu.name));
                    break;
                case 'buildingmanagement':
                    // 招商员：仅商办管理
                    menuNames = ['商办管理'];
                    this.authMenuList = this.allMenuList.filter(menu => menuNames.includes(menu.name));
                    break;
                case 'propertymanager':
                    // 物业公司：仅物业管理
                    menuNames = ['物业管理'];
                    this.authMenuList = this.allMenuList.filter(menu => menuNames.includes(menu.name));
                    break;
                default:
                    // 无权限角色：空菜单（或可自定义默认展示）
                    this.authMenuList = [];
                    console.warn('当前用户角色无菜单权限：', role);
            }
        }
    }
};
</script>

<style scoped>
/* 核心容器样式强化 - 彻底解决白色底色问题 */
.menu_page {
  position: fixed !important;
  top: 71px !important;
  left: 0 !important;
  width: 180px !important;
  height: calc(100vh - 71px) !important;
  overflow: hidden !important;
  z-index: 999 !important;
  background-color: #484848 !important;
  /* 新增：确保背景色完全覆盖，防止透色 */
  box-sizing: border-box;
  border: 0 !important;
}

/* 菜单容器样式强化 */
.el-menu {
  border: none !important;
  width: 100% !important;
  height: 100% !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  /* 新增：强制继承背景色，覆盖element-ui默认样式 */
  background-color: #484848 !important;
}

/* 子菜单样式强化 - 关键修复点 */
.el-submenu,
.el-submenu__title,
.el-menu-item,
.el-menu-item:hover,
.el-submenu__title:hover {
  background-color: #484848 !important;
}

/* 子菜单展开区域背景色 - 关键修复点 */
.el-submenu .el-menu {
  background-color: #484848 !important;
}

/* 激活状态样式优化 */
.el-menu-item.is-active {
  background-color: #666 !important; /* 激活项背景色，可根据需求调整 */
  color: #101010 !important;
}

/* 菜单滚动条美化 */
.el-menu::-webkit-scrollbar {
  width: 4px;
}
.el-menu::-webkit-scrollbar-track {
  background: #484848;
}
.el-menu::-webkit-scrollbar-thumb {
  background: #666;
  border-radius: 2px;
}

.fa-margin {
  margin-right: 5px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100%;
}

.el-submenu .el-menu-item {
  min-width: 100%;
}

.hiddenDropdown,
.hiddenDropname {
  display: none;
}

a {
  text-decoration: none;
}

/* 修复菜单项样式 */
.el-menu-item, 
.el-submenu__title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 新增：覆盖router-link激活时的默认样式 */
a.router-link-active {
  text-decoration: none;
}
</style>